import { useQuery } from 'react-query'
import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { masterDataAtom } from '@/jotai/master.jotai'
import HttpRequest from '@/config/axios.config'
import { isEmptyValue } from '@/utils/common'
import { orderCompanyIdAtom } from '@/screens/Order/jotai/order.jotai'

const getMasterData = async (company_id = '') => {
  const { data } = await HttpRequest.get('properties', {
    params: {
      ...(!isEmptyValue(company_id) && { company_id }),
    },
  })
  return data.data
}

export default function useMasterData() {
  const [orderCompanyId]: any = useAtom(orderCompanyIdAtom)

  const { data, isFetching, refetch, isFetched, isLoading } = useQuery(
    ['getMasterData', orderCompanyId],
    () => getMasterData(orderCompanyId)
  )

  const [, setMasterData] = useAtom(masterDataAtom)

  useEffect(() => {
    const myData = new Map()
    data?.forEach((element) => {
      myData.set(element.name, element)
    })
    setMasterData(myData)
  }, [data])

  return { data: data ?? [], isFetching, refetch, isFetched, isLoading }
}
